var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as Enumerable from "linq";
import { BrandingBase } from "./branding-base";
import { LookupValueRequest, LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { BrandingType } from "../../../../services/modules/brand-client.service";
var BrandingLanguageBase = /** @class */ (function (_super) {
    __extends(BrandingLanguageBase, _super);
    function BrandingLanguageBase(notificationService, i18N, brandClientService, bindingEngine, eventAggregator, lookupClientService, tokenClient, bindingSignaler) {
        var _this = _super.call(this, notificationService, i18N, brandClientService, bindingEngine, eventAggregator, tokenClient, bindingSignaler) || this;
        _this.lookupClientService = lookupClientService;
        _this.languages = [];
        return _this;
    }
    BrandingLanguageBase.prototype.onModelSet = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.languages;
        this.lookupClientService.getLookup(request).then(function (x) {
            if (_this.isManagingDefaultConfig) {
                _this.languages = x.values;
                _this.intializeLanguages();
            }
            else {
                var brandLanguages = Enumerable.from(_this.getBrandDetails().brandLanguages).select(function (x) { return Number(x); });
                _this.languages = Enumerable.from(x.values)
                    .where(function (y) { return brandLanguages.contains(y.id); }).toArray();
                _this.intializeLanguages();
            }
        });
    };
    BrandingLanguageBase.prototype.intializeLanguages = function () {
        var e_1, _a;
        if (!this.model)
            return;
        var brandingType = this.getBrandingType();
        try {
            for (var _b = __values(this.languages), _c = _b.next(); !_c.done; _c = _b.next()) {
                var lang = _c.value;
                if (brandingType) {
                    if (!this.model[lang.additionalData.code])
                        this.model[lang.additionalData.code] = {};
                }
                else {
                    for (var key in this.model) {
                        if (key != "key" && !this.model[key][lang.additionalData.code])
                            this.model[key][lang.additionalData.code] = {};
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    BrandingLanguageBase.prototype.setKeys = function (model) {
        var brandingType = this.getBrandingType();
        if (brandingType == BrandingType.Featured) {
            return [];
        }
        else if (brandingType) {
            return Object.keys(model["en"]);
        }
        else { // this is for ads
            return Object.keys(model[BrandingType.Images]["en"]);
        }
    };
    BrandingLanguageBase.prototype.getFlag = function (lang) {
        var isKnown = !!lang &&
            Array.isArray(this.languages) &&
            this.languages.some(function (x) { var _a; return ((_a = x === null || x === void 0 ? void 0 : x.additionalData) === null || _a === void 0 ? void 0 : _a.code) === lang; });
        var code = isKnown ? lang : "default";
        return "".concat(__CDN_IMAGES__, "/localization/").concat(code, ".svg");
    };
    return BrandingLanguageBase;
}(BrandingBase));
export { BrandingLanguageBase };
